export enum FiltersDataHooks {
  FILTERS_WRAPPER = 'filter-wrapper',
  FILTER_DIVIDER = 'header-divider',
  FILTER_CTA = 'filter-cta',
  OPTION = 'option',
  NOTE_DIVIDER = 'note-divider',
  NOTE = 'note',
}
